var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Shipment Scanner Component
 * Handles scanning shipment ID or bin ID to start packing workflow
 */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Form, message } from 'antd';
import { useTranslation } from 'react-i18next';
import Input from '@fp-suite/core-ui/src/components/Input';
import { usePackingState } from '../../../hooks/packing';
export var ShipmentScanner = function (_a) {
    var onScanComplete = _a.onScanComplete;
    var t = useTranslation().t;
    var form = Form.useForm()[0];
    var _b = useState(''), errorMessage = _b[0], setErrorMessage = _b[1];
    var _c = useState(false), hasError = _c[0], setHasError = _c[1];
    var inputRef = useRef(null);
    var _d = usePackingState(), loading = _d.loading, loadShipmentDetails = _d.loadShipmentDetails, loadShipmentList = _d.loadShipmentList, setContainer = _d.setContainer, toggleScanThroughPack = _d.toggleScanThroughPack;
    // Handle shipment scan
    var handleShipmentScan = useCallback(function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var value, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(event.key === 'Enter')) return [3 /*break*/, 4];
                    value = (_a = event.target.value) === null || _a === void 0 ? void 0 : _a.trim();
                    if (!value) {
                        setErrorMessage(String(t('This is required Field')));
                        setHasError(true);
                        return [2 /*return*/];
                    }
                    setHasError(false);
                    setErrorMessage('');
                    form.setFieldsValue({ shipmentId: '' });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, loadShipmentDetails(value)];
                case 2:
                    _b.sent();
                    toggleScanThroughPack(false);
                    onScanComplete === null || onScanComplete === void 0 ? void 0 : onScanComplete();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    setErrorMessage(String(t('Failed to load shipment')));
                    setHasError(true);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [form, loadShipmentDetails, onScanComplete, toggleScanThroughPack, t]);
    // Handle bin scan
    var handleBinScan = useCallback(function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var value, error_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(event.key === 'Enter')) return [3 /*break*/, 4];
                    value = (_a = event.target.value) === null || _a === void 0 ? void 0 : _a.trim();
                    if (!value) {
                        setErrorMessage(String(t('This is required Field')));
                        setHasError(true);
                        return [2 /*return*/];
                    }
                    setHasError(false);
                    setErrorMessage('');
                    form.setFieldsValue({ binId: '' });
                    setContainer(value);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, loadShipmentList(value)];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _b.sent();
                    message.error(String(t('Failed to load shipment list')));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [form, loadShipmentList, setContainer, t]);
    useEffect(function () {
        if (!loading.shipment) {
            var timeout_1 = setTimeout(function () {
                var _a;
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, 100);
            return function () {
                clearTimeout(timeout_1);
            };
        }
    }, [loading.shipment]);
    return (_jsx("div", __assign({ className: 'w-full' }, { children: _jsx("div", __assign({ className: 'bg-white p-8 rounded-lg shadow-sm justify-center' }, { children: _jsxs(Form, __assign({ form: form, layout: 'vertical' }, { children: [_jsx(Form.Item, __assign({ name: 'shipmentId', validateStatus: hasError ? 'error' : '', help: hasError ? errorMessage : undefined }, { children: _jsx(Input, { ref: inputRef, placeholder: '', title: String(t('Scan or enter Shipment ID')), onKeyDown: handleShipmentScan, autoFocus: true, isDisabled: loading.shipment }, void 0) }), void 0), _jsx(Form.Item, __assign({ name: 'binId', validateStatus: hasError ? 'error' : '', help: hasError ? errorMessage : undefined }, { children: _jsx(Input, { placeholder: '', title: String(t('Scan or enter Bin ID')), onKeyDown: handleBinScan, isDisabled: loading.shipmentList }, void 0) }), void 0)] }), void 0) }), void 0) }), void 0));
};
export default ShipmentScanner;
